
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 255.69 255.69"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('g',{attrs:{"data-name":"Layer 1"}},[_c('circle',{attrs:{"cx":"127.84","cy":"127.84","r":"127.84","fill":"#1e1e1e"}}),_c('path',{attrs:{"d":"M161.37 74.1H93.72l-34.54 39.74L127.31 199l68.12-84.68zm-66.24 45.42l18.35 44-35.22-44zm52.05 0l-19.87 47.69-19.87-47.69zM111 108.17l16.27-19.52 16.26 19.52zm48.44 11.35h17.19L141 163.87zm15.86-11.35h-17l-18.87-22.71h16.68zM98.9 85.46h16.29l-18.93 22.71h-17.1z","fill":"#fff"}})])])])
          )
        }
      }
    